import { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { API_URL } from "../../shared/constant";
import { Watch } from "react-loader-spinner";
import { toast } from "react-toastify";
import axios from "axios";
import Crop from "../../shared/crop";


const AddSlider = () => {
    let { id } = useParams();
    const navigate = useNavigate();
    const [isError, setError] = useState(false);
    const [loading, setLoading] = useState(false);
    const [imagePreview, setImagePreview] = useState("");
    const [formValue, setFormValue] = useState({
        id: null,
        title: "",
        sub_title: "",
        photo: "",
    });

    const saveSize = () => {
        if (formValue.title &&
            (id ? true : formValue.photo)
        ) {
            setError(false);
            setLoading(true);
            const pUrl = id ? API_URL.SLIDER_UPDATE : API_URL.SLIDER_SAVE;
            axios
                .post(pUrl, formValue)
                .then((res) => {
                    setLoading(false);
                    if (res.data.status === 1) {
                        let message = id
                            ? "Slider Updated Successfully."
                            : "Slider Created Successfully.";
                        toast.success(message, { autoClose: 3000, position: "top-right" });
                        setLoading(false);
                        navigate("/slider");
                    } else {
                        toast.error(res.data.data)
                    }
                })
                .finally(() => {
                    setLoading(false);
                    setError(true);
                });
        } else {
            setLoading(false);
            setError(true);
        }
    };
    const isRequiredField = (key) => {
        return isError && !formValue[key];
    };

    const isShowError = (value) => {
        if (
            isError &&
            (!value || value == "" || value == null || value == undefined)
        ) {
            return true;
        }
        return false;
    };

    const onEdit = () => {
        axios.post(API_URL.SLIDER_GET, { id: id }).then((res) => {
            if (res.data.status === 1) {
                setFormValue({
                    id: res.data.data.id,
                    title: res.data.data.title ? res.data.data.title : "",
                    sub_title: res.data.data.sub_title ? res.data.data.sub_title : "",
                    photo: "",
                });
                if (res.data.data.image) {
                    setImagePreview(res.data.data.image);
                }
            }
        });
    };


    const getInputStyles = (isError) => ({
        borderColor: isError ? "red" : undefined,
    });

    useEffect(() => {
        id && onEdit();
    }, [id]);

    return (
        <>
            <div className="row">
                <div className="col-6">
                    <h1>{id ? "Edit" : "Add"} Slider</h1>
                </div>
                <div className="col-6">
                    <div className="d-flex align-items-center  justify-content-end">
                        <Link to={"/slider"} className="btn btn-secondary">
                            <i className="fa fa-backward me-2" aria-hidden="true"></i>Back
                        </Link>
                    </div>
                </div>
                <div className="col-12">
                    <div className="card">
                        <div className="card-body">
                            <form onSubmit={(event) => event.preventDefault()}>
                                <div className="row">
                                    <div className="col-md-3">
                                        <div className="form-group">
                                            <label>
                                                Title<span className="required-star">*</span>
                                            </label>
                                            <input
                                                type="text"
                                                name="title"
                                                value={formValue.title}
                                                className={
                                                    isRequiredField("title")
                                                        ? "form-control required"
                                                        : "form-control"
                                                }
                                                id="title"
                                                style={getInputStyles(isShowError(formValue.title))}
                                                onChange={(event) => {
                                                    setFormValue({
                                                        ...formValue,
                                                        title: event.target.value,
                                                    });
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div className="form-group">
                                            <label>
                                                Sub Title
                                            </label>
                                            <input
                                                type="text"
                                                name="name"
                                                value={formValue.sub_title}
                                                className="form-control"
                                                id="sub_title"
                                                style={getInputStyles(
                                                    isShowError(formValue.sub_title)
                                                )}
                                                onChange={(event) => {
                                                    setFormValue({
                                                        ...formValue,
                                                        sub_title: event.target.value,
                                                    });
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <label>Image<span className="required-star">*</span></label>
                                        <div
                                            className={isRequiredField("photo") && "required-box"}
                                        >
                                            <div>
                                                <Crop
                                                    imagePreview={imagePreview}
                                                    cropShape={"rect"}
                                                    aspectRatio={"5/3"}
                                                    guid={""}
                                                    width={300}
                                                    height={169}
                                                    onChangeCropper={async ({
                                                        fileCroppedBase64,
                                                    }) => {
                                                        setFormValue({
                                                            ...formValue,
                                                            photo: fileCroppedBase64,
                                                        });
                                                        setImagePreview(fileCroppedBase64)
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-12 col-md-12 col-sm-12">
                                    <div className="form-group text-right">
                                        <button
                                            type="submit"
                                            onClick={saveSize}
                                            // disabled={loading}
                                            className="btn btn-primary"
                                        >
                                            {loading ? (
                                                <div
                                                    style={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                    }}
                                                >
                                                    <Watch color={"white"} height={20} width={20} />
                                                </div>
                                            ) : (
                                                "Save"
                                            )}
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default AddSlider;
